export let Code = {
type: `@Component({
    selector: 'p-button',
    template:
        <p-button label="Primary"></p-button>
        <p-button label="Secondary" styleClass = 'ui-button-secondary'></p-button>
        <p-button label="Success" styleClass = 'ui-button-success'></p-button>
        <p-button label="Info" styleClass = 'ui-button-info'></p-button>
        <p-button label="Warning" styleClass = 'ui-button-warning'></p-button>
        <p-button label="Danger" styleClass = 'ui-button-danger'></p-button>
})
export class Button {

}
`,
typeClick: `@Component({
    selector: 'p-button',
    template:
        <p-button label="Click" (onClick)="handleClick($event)"></p-button>
})
export class ButtonClick {

}
`,
typeIcon: `@Component({
    selector: 'p-button',
    template:
        <p-button label="Click" icon="ion-checkmark-round" iconPos="left"></p-button>
        <p-button label="Click" icon="ion-checkmark-round" iconPos="right"></p-button>
})
export class ButtonIcon {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/button.ts